<template>
  <div class="ip-project-detail-wrap">
    <TitleCard
      :title="`产业导航`"
      :showMore="false"
      :loading="loading"
      :isEmpty="emtyOpt.isEmpty"
    >
    </TitleCard>
    <div class="detail-box" v-if="!emtyOpt.isEmpty">
      <div>
        <a-list item-layout="horizontal" :data-source="resultList">
          <a-list-item
            size="small"
            slot="renderItem"
            key="item.id"
            slot-scope="item"
            class="item"
          >
            <a-list-item-meta :description="item.dateRange">
              <a slot="title" @click="toDetails(item)">{{ item.title }}</a>
              <a-avatar slot="avatar" src="/static/icon-shezhi.svg" />
            </a-list-item-meta>
            <div>{{ item.publishDate || '-' }}</div>
          </a-list-item>
        </a-list>
        <Pagination
          :total="total"
          @pageChange="handleChange"
          :pageSize="defaultParams.pageSize"
        ></Pagination>
      </div>
    </div>
    <a-modal
      :title="title"
      :visible="visible"
      width="1000px"
      :footer="null"
      @cancel="handleCancel"
    >
      <div>
        <iframe
          :src="pdfUrl"
          width="100%"
          height="600px"
          class="iframeBox"
        ></iframe>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { infoList } from '@/api/technicalR'
import Pagination from '@/components/common/Pagination'
import { Mixin } from './mixins'
export default {
  data() {
    return {
      emtyOpt: {
        isEmpty: false
      },
      resultList: [],
      list: [],

      total: 0,
      id: 0,
      loading: false,
      defaultParams: {
        pageSize: 10,
        pageNum: 1,
        status: 1
      }
    }
  },
  mixins: [Mixin],
  created() {
    this.loadData()
  },
  components: {
    Pagination
  },
  methods: {
    //渲染列表数据
    async loadData() {
      try {
        this.loading = true
        const { rows, total } = await infoList(this.defaultParams)
        console.log(rows)
        this.emtyOpt.isEmpty = rows.length === 0
        this.resultList = rows
        this.total = total
        this.loading = false
      } catch (error) {
        this.$apiStatusHandler(99, error.message)
      } finally {
        this.loading = false
      }
    },

    // 分页器参数变化，带动列表的数据变化
    handleChange(e) {
      this.defaultParams.pageNum = e
      this.loadData()
    }
  }
}
</script>

<style scoped lang="scss">
/deep/.detail-box {
  min-height: 400px;
  .ant-list-item-meta-avatar {
    width: 48px;
    height: 48px;
    margin-right: 10px;
    .ant-avatar-image {
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
  .ant-list-item-meta {
    align-items: center;
  }
}
</style>
